import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import { StoreTable } from "@/models/tableModel";

interface EditTableDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  table: StoreTable | null;
  onSave: (tableData: { name: string; number: string }) => Promise<void>;
}

export function EditTableDialog({
  open,
  onOpenChange,
  table,
  onSave,
}: EditTableDialogProps) {
  const { t } = useTranslation();
  const [name, setName] = useState(table?.name || "");
  const [number, setNumber] = useState(table?.number?.toString() || "");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSave({ name, number });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("tableCard.editTable")}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="name">{t("tableCard.tableName")}</label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t("tableCard.enterTableName")}
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="number">{t("tableCard.tableNumber")}</label>
            <Input
              id="number"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              placeholder={t("tableCard.enterTableNumber")}
            />
          </div>
          <div className="flex justify-end space-x-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              {t("tableCard.cancel")}
            </Button>
            <Button type="submit">{t("tableCard.save")}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
